import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0h32v38H0z"
}), React.createElement("path", {
  d: "M14.94 37.338l-14-8.75A2 2 0 010 26.892V11.108a2 2 0 01.94-1.696l14-8.75a2 2 0 012.12 0l14 8.75a2 2 0 01.94 1.696v15.784a2 2 0 01-.94 1.696l-14 8.75a2 2 0 01-2.12 0z",
  fill: "#AE9576"
}), React.createElement("path", {
  d: "M5.731 15.62c5.994 1.722 9.113 4.898 8.734 11.532l-4.699-5.09c-.354-.514-.6-.835-.665-.829-.016.002-.002.054.038.148l-.506-.547 3.174 7.935c-4.44-1.598-7.902-5.6-6.076-13.148z",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M27.427 12.334c1.385 7.558-.238 12.778-7.225 16.052l2.01-8.119-5.497 6.622c-.865-6.003 1.433-12.36 10.712-14.555z",
  fillOpacity: 0.75,
  fill: "#F7ECE0"
}));

var SvgMinteLogoLarge = function SvgMinteLogoLarge(props) {
  return React.createElement("svg", props, _ref);
};

export default SvgMinteLogoLarge;